// Portefeuille.js
import React from 'react';
import MenuClient from '../Components/menuclient';
import { motion } from 'framer-motion';
import { Euro, ArrowDownToLine, CreditCard, Eye } from 'lucide-react';
import { Link } from 'react-router-dom';

const Portefeuille = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={styles.container}
    >
      <header style={styles.header}>
        <motion.h2 style={styles.bankName} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
          AidFoundation Banque
        </motion.h2>

        <h3 style={styles.welcome}>Bienvenue, <strong>LEBEL ELOGE</strong></h3>

        <div style={styles.soldeContainer}>
          <p style={styles.label}>Solde disponible</p>
          <motion.h1
            style={styles.solde}
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.3, type: 'spring', stiffness: 100 }}
          >
            10 000,00 €
          </motion.h1>
        </div>

        <div style={styles.actions}>
  <Link to="/banque/compte" style={styles.link}>
    <button style={styles.button}><Eye size={16} /> Voir mon IBAN</button>
  </Link>
  <Link to="/banque/virement" style={styles.link}>
    <button style={styles.button}><ArrowDownToLine size={16} /> Effectuer un virement</button>
  </Link>
  <Link to="/banque/carte" style={styles.link}>
    <button style={styles.button}><CreditCard size={16} /> Ma carte virtuelle</button>
  </Link>
</div>
      </header>

      <section style={styles.transactions}>
        <h3 style={styles.transactionsTitle}>Historique des transactions</h3>

        <motion.div
          style={styles.transactionItem}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4 }}
        >
          <span>✔ Virement reçu de AidFoundation</span>
          <span style={styles.amount}>+ 10 000,00 €</span>
        </motion.div>
        <div style={styles.transactionDate}>13/07/2025 • 22:46</div>
      </section>

      <MenuClient />
    </motion.div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    paddingBottom: '80px',
    backgroundColor: '#F9FAFB',
    color: '#000',
    minHeight: '100vh',
  },
  header: {
    padding: '20px',
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E5E7EB',
    boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
  },
  bankName: {
    color: '#0061A6',
    fontSize: '20px',
    marginBottom: '10px',
  },
  welcome: {
    fontSize: '16px',
    color: '#1F2937',
  },
  soldeContainer: {
    marginTop: '15px',
    marginBottom: '20px',
  },
  label: {
    fontSize: '14px',
    color: '#6B7280',
  },
  solde: {
    fontSize: '36px',
    fontWeight: 'bold',
    color: '#111827',
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '10px',
  },
  button: {
    flex: '1 1 30%',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '12px',
    backgroundColor: '#0061A6',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'background 0.3s',
  },
  transactions: {
    padding: '20px',
    backgroundColor: '#FFFFFF',
    marginTop: '10px',
  },
  transactionsTitle: {
    fontSize: '16px',
    marginBottom: '15px',
    color: '#0061A6',
  },
  transactionItem: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '15px',
    fontWeight: 'bold',
  },
  transactionDate: {
    fontSize: '13px',
    color: '#6B7280',
    marginTop: '5px',
  },
  amount: {
    color: '#16A34A',
  },
};

export default Portefeuille;
